import { createQuery, createSuspenseQuery } from 'react-query-kit';

import { getZepetofulCDNContent } from '@/api/zepetoful.api/zepetoful.api';
import { type PromotionNewMapDataType } from '@/module/play/modal';
import { type SelectionSchoolInfo } from '@/views/build/type';

import { type NewMapBannerContent } from './model';

export const ZepetofulSchoolContentQueryOptions = {
  queryKey: ['zepetoful-school-content'],
  variables: {
    entryId: '3trmXRiMwUttqHz9B4gjHr846J74sf',
  },
  fetcher: getZepetofulCDNContent,
};

export const useZepetofulSuspenseSchoolContent = createSuspenseQuery<
  SelectionSchoolInfo,
  { entryId: string }
>({
  ...ZepetofulSchoolContentQueryOptions,
});

export const useZepetofulFetchSchoolContent = createQuery<
  SelectionSchoolInfo,
  { entryId: string }
>({
  ...ZepetofulSchoolContentQueryOptions,
});

export const getZepetofulFetchSchoolContentQueryKey = () => {
  return useZepetofulFetchSchoolContent.getKey({
    ...ZepetofulSchoolContentQueryOptions.variables,
  });
};

export const useZepetofulNewMapSuspenseQuery = createSuspenseQuery<
  PromotionNewMapDataType,
  { entryId: string }
>({
  queryKey: ['grfiW3wK886uLHnh12ZtPSY'],
  fetcher: getZepetofulCDNContent,
  variables: {
    entryId: 'grfiW3wK886uLHnh12ZtPSY',
  },
});

export const useZepetofulNewMapBannerContent = createQuery<
  NewMapBannerContent,
  { entryId: string }
>({
  queryKey: ['zepetoful-new-map-banner-content'],
  fetcher: getZepetofulCDNContent,
  variables: {
    entryId: 'Y9aWp3wK87XuWn3RDPxTg97',
  },
});
